import React from "react";
import { useNavigateWithParams } from "utils/components/LinkWithParams";
import { DefaultButton, IButtonProps } from "@fluentui/react";

type Props = {
  to: string;
} & Omit<IButtonProps, "href">;

const ButtonLink: React.FC<Props> = ({ to, ...rest }) => {
  const navigate = useNavigateWithParams();

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = e => {
    e.preventDefault();
    navigate(to);
  };

  return <DefaultButton href={to} onClick={handleClick} {...rest} />;
};

export default ButtonLink;
